import React, { useEffect } from "react";
import { animateScroll as scroll } from "react-scroll";
import { logEvent } from "firebase/analytics";
import { useLocation } from "react-router-dom";

import FarmStart from "./start/FarmStart";
import FarmNavigation from "./start/FarmNavigation";
import { scrollToFarmSection } from "./start/farmNavigationScroll";
import FarmInfo from "./info/FarmInfo";
import FarmProductsNew from "./products/FarmProductsNew";
import FarmPartners from "./partners/FarmPartners";
import ContactOuter from "../contact/ContactOuter";
import { analyticsObj } from "../../components/firebase/firestore";
import "./farmOuter.css";
import "./farmLanding.css";

const routesArray = [
  "farm/info",
  "farm/products",
  "farm/partners",
  "farm/contact",
];

function FarmOuter() {
  const location = useLocation();

  useEffect(() => {
    const pathFromUrl = location.pathname.substring(1);
    if (routesArray.includes(pathFromUrl)) {
      scrollToFarmSection(pathFromUrl, { delay: 80 });
    } else {
      scroll.scrollToTop();
    }
  }, [location.pathname]);

  useEffect(() => {
    logEvent(analyticsObj, "page_view");
  }, [location.pathname]);

  return (
    <div className="FarmOuter FarmLanding">
      <FarmNavigation />
      <FarmStart />
      <FarmInfo />
      <FarmProductsNew />
      <FarmPartners />
      <ContactOuter />
    </div>
  );
}

export default FarmOuter;
